import React from "react";

const Washing_26 = React.forwardRef(
  ({ width = "41", height = "32", viewBox = "0 0 41 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 2H34V7.04744L20.1536 14.972L6 6.8447V2ZM4 5.69625L1.04602 4L0.016932 5.72152L4 8.0087V24.2171L0 26.5064L1.02583 28.2295L4 26.5274V32H36V26.3839L39.2592 28.2554L40.2883 26.5339L36 24.0714V8.21306L40.3054 5.74901L39.2795 4.02586L36 5.9028V0H4V5.69625ZM34 9.3577L22.1686 16.1291L34 22.923V9.3577ZM34 25.2354L20.1517 17.2834L6 25.3827V30H34V25.2354ZM6 23.0725L18.1367 16.1263L6 9.15715V23.0725Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_26;
